import {MODALITY, Modality} from '@domain/model/Account/Subscription/Subscription';

export const isCancellingPlan = (modality: Modality): boolean => modality === MODALITY.ON_DEMAND;
